import React, { Component } from "react";
import logo1080 from "./img/MUSEAbadge-black-p-1080.jpeg";
import logo500 from "./img/MUSEAbadge-black-p-500.jpeg"
import logo800 from "./img/MUSEAbadge-black-p-800.jpeg"
import logoBlack from "./img/MUSEAbadge-black.jpg"

class ShopifyConnect extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.innerHtml = "";
    document.body.appendChild(script);
  }

  render() {

    let logoSrcSet = `${logo500} 500w, ${logo800} 800w, ${logo1080} 1080w, ${logoBlack} 1200w`
    return (
      <div className="SignUp">

      <div>
        <img alt="musea logo"
          srcSet={logoSrcSet}
          sizes="144px"
          className="image"
          src={logoBlack}
          style={{width: "144"}}
          />

          <div style={{textAlign: 'center', marginTop: '5%', marginLeft: 'auto', marginRight: 'auto', width: '100%', fontSize: '22pt', fontWeight: '700'}}>
            X
          </div>

          <div className="image" style={{textAlign: 'center'}}>
            <svg style={{width: '10%'}} focusable="false" aria-hidden="true" class="ui-inline-svg" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 144"><g fill="none" fill-rule="evenodd"><path d="M107.4 27.4c-.1-.7-.7-1-1.2-1L95.8 26l-9.1-8.9c-.8-.8-2.4-.6-3-.4l-4.2 1.3c-.4-1.4-1.1-3-2-4.9-2.9-5.6-7.3-8.6-12.5-8.6l-1.1.1-.5-.5A11.1 11.1 0 0054.7.7C48 1 41.3 5.8 35.8 14.4A56.4 56.4 0 0028.2 34l-13.3 4.1c-3.9 1.2-4 1.3-4.5 5C10.2 46 0 124.8 0 124.8l85.6 14.8 37.1-9.2-15.3-103zm-32.2-7.9l-6.6 2.1a37 37 0 00-2-12.2c5.1.8 7.6 6.6 8.6 10.1zM64.1 23c-4.5 1.4-9.4 3-14.3 4.4 1.4-5.3 4-10.5 7.2-14 1.2-1.3 2.9-2.7 4.8-3.5 2 4 2.4 9.4 2.3 13.1zM54.9 5.2c1.6 0 2.9.3 4 1.1-1.8 1-3.6 2.3-5.2 4.1A39 39 0 0044.8 29l-11.7 3.6c2.4-10.9 11.5-27 21.8-27.4z" fill="#95BF47"></path><path d="M106.2 26.3l-10.4-.2-9.1-8.9c-.3-.3-.7-.5-1.1-.5v123l37.1-9.3-15.2-103c-.2-.7-.8-1-1.3-1z" fill="#5E8E3E"></path><path d="M65 45.4l-4.3 16.1s-4.8-2.2-10.5-1.8c-8.4.5-8.4 5.8-8.4 7.1.5 7.2 19.4 8.8 20.5 25.7.8 13.3-7 22.4-18.4 23.1a28 28 0 01-21.1-7.3L25.7 96s7.6 5.7 13.6 5.3a5.3 5.3 0 005.2-5.7c-.6-9.4-16-8.8-17-24.3-.8-13 7.7-26 26.5-27.3 7.3-.5 11 1.4 11 1.4z" fill="#FFF"></path><g fill="#000"><path d="M172.9 79.7c-4.3-2.3-6.5-4.3-6.5-7 0-3.4 3.1-5.6 7.9-5.6 5.6 0 10.6 2.3 10.6 2.3l3.9-12s-3.6-2.8-14.2-2.8c-14.8 0-25.1 8.5-25.1 20.4 0 6.8 4.8 12 11.2 15.6 5.2 3 7 5 7 8.1 0 3.2-2.6 5.8-7.4 5.8-7.1 0-13.9-3.7-13.9-3.7l-4.2 12s6.2 4.2 16.7 4.2c15.2 0 26.2-7.5 26.2-21-.1-7.3-5.6-12.5-12.2-16.3zM233.5 54.4c-7.5 0-13.4 3.6-17.9 9h-.2l6.5-34H205l-16.5 86.5h16.9l5.6-29.6c2.2-11.2 8-18 13.4-18 3.8 0 5.3 2.5 5.3 6.2a38 38 0 01-.7 7.5l-6.4 34h16.9l6.6-35c.7-3.8 1.2-8.2 1.2-11.2.1-9.6-4.9-15.4-13.8-15.4zM285.7 54.4c-20.4 0-33.9 18.4-33.9 39 0 13 8.1 23.6 23.3 23.6 20 0 33.5-17.9 33.5-38.9.1-12-7-23.7-22.9-23.7zm-8.3 49.7c-5.8 0-8.2-4.9-8.2-11 0-9.8 5-25.6 14.2-25.6 6 0 8 5.2 8 10.2 0 10.4-5.1 26.4-14 26.4zM352 54.4c-11.4 0-17.9 10.1-17.9 10.1h-.2l1-9h-15a376 376 0 01-3.4 22.4l-11.8 62h16.9l4.7-25h.4s3.5 2.1 9.9 2.1c19.9 0 32.9-20.4 32.9-41 0-11.4-5.1-21.6-17.5-21.6zm-16.2 50c-4.4 0-7-2.6-7-2.6l2.8-15.8c2-10.6 7.5-17.6 13.4-17.6 5.2 0 6.8 4.8 6.8 9.3 0 11-6.5 26.6-16 26.6zM393.7 30.1A9.7 9.7 0 00384 40c0 5 3.2 8.5 8 8.5h.2c5.3 0 9.8-3.6 9.9-9.8 0-4.9-3.3-8.5-8.4-8.5zM370 115.8h16.9l11.5-60h-17zM441.5 55.7h-11.8l.6-2.8c1-5.8 4.4-10.9 10.1-10.9 3 0 5.4 1 5.4 1l3.3-13.4s-2.9-1.5-9.2-1.5c-6 0-12 1.7-16.6 5.6-5.8 5-8.5 12-9.8 19.2l-.5 2.8h-7.9l-2.5 12.8h7.9l-9 47.4h16.9l9-47.4h11.7l2.4-12.8zM482.3 55.8S471.7 82.5 467 97.1h-.2c-.3-4.7-4.2-41.3-4.2-41.3h-17.8L455 111c.2 1.2.1 2-.4 2.8-2 3.8-5.3 7.5-9.2 10.2a39 39 0 01-9.6 4.8l4.7 14.4a39 39 0 0016.6-9.2c7.7-7.2 14.9-18.4 22.2-33.6L500 55.8h-17.7z"></path></g></g></svg>
          </div>
        </div>

      <div class="text-block-24">
          It's time to connect Musea Lab with Shopify.
          <br/>
          Enter your code below to proceed.
          <br/>
          If you don't have a code go to your account profile page to retrieve it.
      </div>
          <a
            style={{textDecoration: 'underline',
              cursor: 'pointer',
              marginLeft: '3px'}}
            href="http://musealab.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link-4"
          >
            Back to MUSEALAB.COM
          </a>

      </div>
    );
  }
}

export default ShopifyConnect;
